import { http } from '@/libs/interfaces'
import { normalizeGeshenType } from '@/components/app/song_item/songTypes'

export const APOLLO_RANK_GROUP_ID = 2
export const APOLLO_VIP_SONGS_TAG = 'A007'
export const APOLLO_VIP_SONGS_PAY_TP = 'TOP-VIPSongs-yzs-role2'
export const APOLLO_DEFAULT_TOP = { id: 'A001', name: '高质歌曲' }

function getApolloHost() {
  return process.env.NODE_ENV === 'production'
    ? 'https://apollo.ktvsky.com'
    : 'https://apoerp.ktvsky.com'
}

function inferSongType(raw) {
  if (raw.FirstSongs > 0) return 'vip_first'
  if (raw.DJmixSongs > 0) return 'djhot'
  if (raw.HighSongs > 0) return 'geshen'
  if (raw.DJingSongs > 0) return 'djhot'
  return ''
}

/**
 * Apollo 榜单歌曲 → song_item 所需格式
 */
export function mapApolloSongToItem(raw) {
  const type = inferSongType(raw)
  const item = {
    songid: raw.songId,
    music_name: raw.songName,
    singer: raw.singerName,
    mvPic: raw.mvPic,
    type,
  }

  if (type === 'geshen' && raw.HighSongs > 0) {
    item.muti_version = [{
      type: 'geshen',
      songid: raw.HighSongs,
      music_name: raw.songName,
      singer: raw.singerName,
    }]
    const hq = { ...item.muti_version[0] }
    hq.versionsSong = true
    hq.muti_version = [{ ...item, muti_version: undefined }]
    normalizeGeshenType(hq)
    return hq
  }

  normalizeGeshenType(item)
  return item
}

/**
 * 获取运营配置的榜单 Tab 列表
 */
export async function fetchApolloRankTabs(groupId = APOLLO_RANK_GROUP_ID) {
  const res = await http.get(`${getApolloHost()}/apollo/playlist/group/api`, {
    params: { group_id: groupId },
  })
  const items = res?.data?.items || []
  return items
    .slice()
    .sort((a, b) => a.sort_order - b.sort_order)
    .map((item) => ({
      id: item.playlist_tag,
      name: item.playlist_name,
      tag: item.playlist_tag,
    }))
}

/**
 * 获取榜单歌曲（默认 50 首，不分页）
 */
export async function fetchApolloRankSongs(tag, size = 50) {
  const res = await http.get(`${getApolloHost()}/apollo/playlist/api`, {
    params: { tag, page: 1, size },
  })
  const list = res?.data?.mediainfo?.list || []
  return list.map(mapApolloSongToItem)
}
